module.exports = __webpack_public_path__ + "img/Group-4645.afe94c26.svg";